"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgStakeholders = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M15.5 11a2.49 2.49 0 002.492-2.5A2.497 2.497 0 1013 8.5c0 1.383 1.117 2.5 2.5 2.5zm-6.667 0a2.49 2.49 0 002.492-2.5 2.497 2.497 0 10-4.992 0c0 1.383 1.117 2.5 2.5 2.5zm0 1.667c-1.941 0-5.833.975-5.833 2.916v1.25c0 .459.375.834.833.834h10a.836.836 0 00.834-.834v-1.25c0-1.941-3.892-2.916-5.834-2.916zm6.667 0a9.73 9.73 0 00-.808.041c.016.009.025.025.033.034.95.691 1.608 1.616 1.608 2.841v1.25c0 .292-.058.575-.15.834H20.5a.836.836 0 00.833-.834v-1.25c0-1.941-3.891-2.916-5.833-2.916z", fill: "currentColor" }) }))); };
exports.default = SvgStakeholders;
